module.exports = __webpack_public_path__ + "img/wii-fit-trainer-min.9d5e5136.png";